<template>
  <div class="instagram-analytics-public">
    <div class="loading-bar" v-if="loading"></div>
    <div class="loading-bar-hide" v-else></div>
    <div v-if="!campaign || !campaign.id"></div>
    <div class="instagram-analytics-public-container" v-else>
      <InstagramInstantwinAnalyticsPublicHeader class="mb-x2"></InstagramInstantwinAnalyticsPublicHeader>
      <InstagramInstantwinAnalyticsPublicFilter class="mb-x2"></InstagramInstantwinAnalyticsPublicFilter>
      <InstagramInstantwinAnalyticsPublicSummary class="mb-x2"></InstagramInstantwinAnalyticsPublicSummary>
      <InstagramInstantwinAnalyticsPublicTabs></InstagramInstantwinAnalyticsPublicTabs>
    </div>
  </div>
</template>

<script lang="ts">
import moment from 'moment'
import { storeToRefs } from 'pinia'
import { defineComponent, getCurrentInstance, onMounted } from 'vue'

import { useInstagramInstantwinAnalyticsPublicStore } from '@/client/features/instagram_instantwin_analytics_public/hooks/instagramInstantwinAnalyticsPublicStore'
import InstagramInstantwinAnalyticsPublicFilter from '@/client/features/instagram_instantwin_analytics_public/instagram_instantwin_analytics_public_filter'
import InstagramInstantwinAnalyticsPublicHeader from '@/client/features/instagram_instantwin_analytics_public/instagram_instantwin_analytics_public_header'
import InstagramInstantwinAnalyticsPublicSummary from '@/client/features/instagram_instantwin_analytics_public/instagram_instantwin_analytics_public_summary'
import InstagramInstantwinAnalyticsPublicTabs from '@/client/features/instagram_instantwin_analytics_public/instagram_instantwin_analytics_public_tabs'
import { getAnalyticsDefaultPeriod } from '@/common/utils/analytics_period'

export default defineComponent({
  components: {
    InstagramInstantwinAnalyticsPublicFilter,
    InstagramInstantwinAnalyticsPublicHeader,
    InstagramInstantwinAnalyticsPublicSummary,
    InstagramInstantwinAnalyticsPublicTabs
  },
  setup() {
    const { proxy } = getCurrentInstance() as { proxy: { $route: { query?: { hash?: string | string[] } } } }
    const store = useInstagramInstantwinAnalyticsPublicStore()
    const { campaign, loading } = storeToRefs(store)

    const initialize = async () => {
      const hashParam = proxy?.$route?.query?.hash
      const hash = Array.isArray(hashParam) ? hashParam[0] : hashParam

      if (!hash) {
        return
      }

      store.setParams({ hash: String(hash) })

      await store.fetchCampaign()
      await store.fetchPrizes()

      if (!campaign.value || !campaign.value.id) {
        return
      }

      const [startDatetime, endDatetime] = getAnalyticsDefaultPeriod(
        campaign.value.startDatetime,
        campaign.value.endDatetime
      )

      store.setParams({
        startDatetime: moment(startDatetime).format('YYYY-MM-DD'),
        endDatetime: moment(endDatetime).format('YYYY-MM-DD')
      })

      await store.fetchCampaignAnalytics()
    }

    onMounted(() => {
      void initialize()
    })

    return {
      campaign,
      loading
    }
  }
})
</script>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.instagram-analytics-public-container {
  max-width: $max-content-width;
  padding: $spacing-unit * 2;
  margin: 0 auto;
  background-color: #fff;

  :deep {
    .instagram-analytics-public-filter {
      .el-input__inner {
        height: $spacing-unit * 5;
      }

      .el-input {
        width: $spacing-unit * 18;

        &.el-input--suffix {
          min-width: $spacing-unit * 22;
        }
      }
    }
  }
}
</style>
